document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('#PrimaryNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open', !expanded);
    });
  }
  document.querySelectorAll('input[type="number"][max="5"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var value = parseInt(input.value || '1', 10);
      if (value > 5) input.value = 5;
      if (value < (input.min === '0' ? 0 : 1)) input.value = input.min === '0' ? 0 : 1;
    });
  });
});